import { render, staticRenderFns } from "./zCampoBuscarCliente.vue?vue&type=template&id=66fbfd62&scoped=true&"
import script from "./zCampoBuscarCliente.vue?vue&type=script&lang=js&"
export * from "./zCampoBuscarCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fbfd62",
  null
  
)

export default component.exports